import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import { BREAKPOINTS } from '../utils';

Swiper.use([Navigation, Pagination]);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $swiperContainer: this.el.querySelector('.swiper'),
      $swiperSlides: this.el.querySelectorAll('.swiper-slide'),
      $swiperPagination: this.el.querySelector('.swiper-pagination'),
      $swiperNextButton: this.el.querySelector('.swiper-button-next'),
      $swiperPrevButton: this.el.querySelector('.swiper-button-prev')
    };

    this.isSmallContainer = this.el.closest('.dual-column-container__main');
    this.initSwiper();
  }

  initSwiper() {
    const slidesPerView = this.isSmallContainer ? 1 : 3;
    const swiperPaginationType = this.isSmallContainer ? 'fraction' : 'bullets';

    this.swiper = new Swiper(this.dom.$swiperContainer, {
      a11y: true,
      rewind: true,
      slidesPerView: 1,
      spaceBetween: 32,
      watchOverflow: true,
      breakpoints: {
        [BREAKPOINTS.TABLET_LANDSCAPE]: {
          slidesPerView,
          pagination: {
            type: swiperPaginationType
          }
        }
      },
      pagination: {
        el: this.dom.$swiperPagination,
        type: 'fraction'
      },
      navigation: {
        nextEl: this.dom.$swiperNextButton,
        prevEl: this.dom.$swiperPrevButton
      },
      watchSlidesProgress: true
    });
  }
}

export default Module;
